import React from 'react';

export const GetIcon = (srcUrl: string, width: number, height: number) => {
  return <img src={srcUrl} width={width} height={height} alt={"logo"} />;
};
